import { render, staticRenderFns } from "./ValidatablePremiumStepSelector.vue?vue&type=template&id=1194bf23&"
import script from "./ValidatablePremiumStepSelector.vue?vue&type=script&lang=js&"
export * from "./ValidatablePremiumStepSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports